

import { BANNERS_DATA } from "./banners_data";
import { BLOGS_DATA } from "./blogs_data";
import { COMMUNITY_DATA } from "./community_data";
import { COURSES_CATEGORIES, COURSES_DATA } from "./courses_data";
import { FEATURES_DATA } from "./features_data";
import { ABOUTUS_Data, CONTACTUS_Data, JOINUS_Data } from "./information_data";
import { ALL_KEYWORDS_DATA } from "./seo_keywords";
import { SERVICES_DATA } from "./services_data";
import { TRUSTED_CLIENTS_DATA } from "./trusted_clients";
import { WORKSHOPS_DATA } from "./workshops_data";

export const MODEL = {
  app: {
    name: "SEED TO TREE Tech Academy & Solutions",
    tagline: "To grow is learn",
    base_url: "https://seedtotree.netlify.app",
    // base_url: "",
    quote:
      "Knowledge is cultivated through effort, Neglect lets ignorance grow",
  },
  api: {
    base_url:
      process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_BASE_API_URL
        : process.env.REACT_APP_BASE_LOCAL_API_URL,
  },
  data: {
    courses: COURSES_DATA,
    courses_categories: COURSES_CATEGORIES,
    blogs: BLOGS_DATA,
    workshops: WORKSHOPS_DATA,
    services: SERVICES_DATA,
    about_us: ABOUTUS_Data,
    join_us: JOINUS_Data,
    contact_us: CONTACTUS_Data,
    banners: BANNERS_DATA,
    keywords: ALL_KEYWORDS_DATA,
    trusted_clients: TRUSTED_CLIENTS_DATA,
    community: COMMUNITY_DATA,
    features: FEATURES_DATA,
  },
};
